// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button {
  background: var(--btn-bg, #17213b);
  position: relative;
  display: inline-flex;
  padding: 17px 25px;
  justify-content: center;
  align-items: center;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  border-radius: 12px;
  text-decoration: none;
  color: #fff;
  transition: all 0.3s ease;
  cursor: pointer;
  overflow: hidden;
  width: auto;
  border: none;
  outline: none;
}
.button span.button__effect {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.15);
  transition: width 0.4s ease-in-out, height 0.4s ease-in-out;
  transform: translate(-50%, -50%);
  z-index: 0;
}
.button span.button__name {
  position: relative;
  z-index: 1;
  transition: all 0.3s ease;
}
.button:active {
  transform: translateY(3px);
}
.button:hover {
  color: #fff;
  opacity: 0.8;
  /*  span.button__effect {
      width: 1500px;
      height: 1500px;
    }*/
}
.button:hover .button__name {
  z-index: 2;
}
.button--primary {
  background: var(--btn-bg, #17213b);
}
.button.active {
  background: #dadada;
  color: #000;
}
.button.disabled {
  background: rgb(78, 78, 78) !important;
  cursor: not-allowed;
  pointer-events: none;
}
.button.disabled:active {
  transform: translateY(0px);
}
.button.disabled:hover {
  color: #fff;
}
.button.disabled:hover span.button__effect {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/Button/Button.scss"],"names":[],"mappings":"AACA;EAIE,kCAAA;EAEA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AAJF;AAME;EACE,kBAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EAEA,qCAAA;EACA,2DAAA;EACA,gCAAA;EACA,UAAA;AALJ;AAQE;EACE,kBAAA;EACA,UAAA;EACA,yBAAA;AANJ;AASE;EACE,0BAAA;AAPJ;AAUE;EACE,WAAA;EACA,YAAA;EACF;;;MAAA;AALF;AAUI;EACE,UAAA;AARN;AAWE;EACE,kCAAA;AATJ;AAYE;EACE,mBAAA;EACA,WAAA;AAVJ;AAaE;EAEE,sCAAA;EACA,mBAAA;EACA,oBAAA;AAZJ;AAcI;EACE,0BAAA;AAZN;AAeI;EACE,WAAA;AAbN;AAcM;EACE,aAAA;AAZR","sourcesContent":["@import '../../../styles/_variables';\r\n.button {\r\n  $self: &;\r\n\r\n  // Используем переданный цвет из пропсов, иначе fallback на переменную из стилей\r\n  background: var(--btn-bg, #17213b);\r\n\r\n  position: relative;\r\n  display: inline-flex;\r\n  padding: 17px 25px;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n  line-height: 100%;\r\n  border-radius: 12px;\r\n  text-decoration: none;\r\n  color: #fff;\r\n  transition: all 0.3s ease;\r\n  cursor: pointer;\r\n  overflow: hidden;\r\n  width: auto;\r\n  border: none;\r\n  outline: none;\r\n\r\n  span.button__effect {\r\n    position: absolute;\r\n    display: block;\r\n    width: 0;\r\n    height: 0;\r\n    border-radius: 50%;\r\n    // Можно также сделать переменную для цвета эффекта: var(--btn-effect, #002789)\r\n    background-color: rgba(0, 0, 0, 0.15);\r\n    transition: width 0.4s ease-in-out, height 0.4s ease-in-out;\r\n    transform: translate(-50%, -50%);\r\n    z-index: 0;\r\n  }\r\n\r\n  span.button__name {\r\n    position: relative;\r\n    z-index: 1;\r\n    transition: all 0.3s ease;\r\n  }\r\n\r\n  &:active {\r\n    transform: translateY(3px);\r\n  }\r\n\r\n  &:hover {\r\n    color: #fff;\r\n    opacity: 0.8;\r\n  /*  span.button__effect {\r\n      width: 1500px;\r\n      height: 1500px;\r\n    }*/\r\n\r\n    #{$self}__name {\r\n      z-index: 2;\r\n    }\r\n  }\r\n  &--primary{\r\n    background: var(--btn-bg, #17213b);\r\n  }\r\n\r\n  &.active{\r\n    background: #dadada;\r\n    color: #000;\r\n  }\r\n\r\n  &.disabled {\r\n    // !important нужен, чтобы перебить inline style, если передан цвет\r\n    background: rgba(78, 78, 78, 1) !important;\r\n    cursor: not-allowed;\r\n    pointer-events: none;\r\n\r\n    &:active {\r\n      transform: translateY(0px);\r\n    }\r\n\r\n    &:hover {\r\n      color: #fff;\r\n      span.button__effect {\r\n        display: none;\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
